import React, { useState, useEffect } from 'react';
import { ChevronUp, ChevronDown, Eye, EyeOff, Download, X } from 'lucide-react';
import { Button } from '../../Common/Button';
import CommonTable from '../../Common/CommonTable';
import { getVehicleClassData } from '../../Utils/helper';
import { ErrorToast, SuccessToast } from '../../Utils/toast';
import moment from 'moment';
import CommonModal from '../../Commponent/CommonModal';
import { API } from '../../Common/Api';
import CommonTableModal from '../../Commponent/CommonTableModal';
import { useDispatch, useSelector } from 'react-redux';
import { ACTIONS } from '../../redux/actions';
import { getRole } from '../../Utils/auth';

//distributor MyAgentsRequest; 
const MyAgentsRequest = () => {
  const dispatch = useDispatch();
  const updateStatusData = useSelector(state => state.UpdateAgentRequestStatus?.UpdateAgentRequestStatusData);
  const refreshCount = useSelector((state) => state.Refresh?.refreshCount);

  // Logged-in user's role (read from localStorage `UserDetail`).
  const role = getRole();
  const isDistributor = role === 'distributor';

  const [activeTab, setActiveTab] = useState('agentRequest');
  const [visibleRows, setVisibleRows] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedClass, setSelectedClass] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [approvalNote, setApprovalNote] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: "", direction: null });
  const [assigningAgent, setAssigningAgent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [viewDetailsModalOpen, setViewDetailsModalOpen] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  // Agent Requests states
  const [agentRequests, setAgentRequests] = useState([]);
  const [agentRequestsLoading, setAgentRequestsLoading] = useState(false);
  const [agentRequestsCurrentPage, setAgentRequestsCurrentPage] = useState(1);
  const [agentRequestsTotalPages, setAgentRequestsTotalPages] = useState(1);
  const [agentRequestsPageSize, setAgentRequestsPageSize] = useState(10);
  const [agentRequestsTotalRecords, setAgentRequestsTotalRecords] = useState(0);

  // Dealer Requests states (distributor only)
  const [dealerRequests, setDealerRequests] = useState([]);
  const [dealerRequestsLoading, setDealerRequestsLoading] = useState(false);
  const [dealerRequestsCurrentPage, setDealerRequestsCurrentPage] = useState(1);
  const [dealerRequestsTotalPages, setDealerRequestsTotalPages] = useState(1);
  const [dealerRequestsPageSize, setDealerRequestsPageSize] = useState(10);
  const [dealerRequestsTotalRecords, setDealerRequestsTotalRecords] = useState(0);

  // My Fastag Requests states
  const [myFastagRequests, setMyFastagRequests] = useState([]);
  const [myFastagRequestsLoading, setMyFastagRequestsLoading] = useState(false);
  const [myFastagRequestsCurrentPage, setMyFastagRequestsCurrentPage] = useState(1);
  const [myFastagRequestsTotalPages, setMyFastagRequestsTotalPages] = useState(1);
  const [myFastagRequestsPageSize, setMyFastagRequestsPageSize] = useState(10);
  const [myFastagRequestsTotalRecords, setMyFastagRequestsTotalRecords] = useState(0);

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction:
            prev.direction === "asc"
              ? "desc"
              : prev.direction === "desc"
                ? null
                : "asc",
        };
      }
      return { key, direction: "asc" };
    });
  };
  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      if (sortConfig.direction === "asc")
        return (
          <ChevronUp className="w-[18px] h-[18px] inline-block ml-1 text-[#9C9C9C]" />
        );
      if (sortConfig.direction === "desc")
        return (
          <ChevronDown className="w-[18px] h-[18px] inline-block ml-1 text-[#9C9C9C]" />
        );
    }
    return (
      <ChevronDown className="w-[18px] h-[18px] inline-block ml-1 text-[#E0E0E0]" />
    );
  };


  const toggleVisibility = (index, row) => {
    const isVisible = visibleRows[index];
    const newVisibility = { ...visibleRows, [index]: !isVisible };
    setVisibleRows(newVisibility);

    if (window.innerWidth >= 0) {
      setModalOpen(!isVisible);
    }

    if (!isVisible) {
      setSelectedClass(row);
      setSelectedIndex(index);
    }
  };

  const vehicleData = getVehicleClassData(selectedClass.vehicleClass);

  const tableColumns = [
    {
      label: "Requested By",
      key: "name",
      render: (row) => (
        <div>
          <div className="font-medium text-[#1F1715]">{row.user?.username}</div>
          <div className="text-xs text-[#000000]">{row.user?.email || ''}</div>
        </div>
      ),
    },
    {
      label: "Mobile Number",
      render: (row) => row.user?.mobileNo || 'N/A'
    },
    {
      label: "Vehicle Class",
      key: "vehicleClass",
      render: (item, idx) => {
        const vehicleClassData = getVehicleClassData(item.vehicleClass);
        return (
          <div className="flex gap-2 items-center">
            <img
              src={vehicleClassData?.tagimage}
              alt="Tag"
              className="w-[34px]"
            />
            <p>{vehicleClassData?.value || item.vehicleClass}</p>
            <div
              className="pl-2 flex items-center cursor-pointer"
              onClick={() => toggleVisibility(idx, item)}
            >
              {visibleRows[idx] ? <Eye className="h-5 w-5" /> : <EyeOff className="h-5 w-5" />}
            </div>
          </div>
        );
      },
    },
    {
      label: "Requested Date",
      render: (row) => moment(row.createdAt).format("DD MMMM, YYYY hh:mm A")
    },
    // {
    //   label: "Received Date",
    //   render: (row) => moment(row.updatedAt).format("DD MMMM, YYYY hh:mm A")
    // },
    {
      label: "Quantity",
      key: "quantity",
      render: (row) => row.quantity || 0
    },
    {
      label: "Action",
      tdClassName: 'flex justify-end',
      render: (row) => (
        <div className="flex gap-2 items-center">
          {row.requestStatus === 'Pending' ? (
            <>
              <Button
                label="Assign +"
                onClick={() => handleAssign(row)}
                roundedButton
                className="!bg-green-500 hover:!bg-green-600 !text-white rounded-full px-3 py-1"
              />
              <Button
                label="Denied"
                onClick={() => handleDeny(row)}
                className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded-full text-sm"
              />
            </>
          ) : (
            <Button
              label="View Details"
              onClick={() => handleViewDetails(row)}
              roundedButton
              className="text-blue-500 rounded-full px-3 py-1"
            />
          )}
        </div>
      )
    }
    // {
    //   label: "Status",
    //   key: "status",
    //   render: (row) => (
    //     <span className={`px-2 py-1 rounded-full text-xs ${row.status === 'Approved' ? 'bg-green-100 text-green-800' :
    //       row.status === 'Pending' ? 'bg-yellow-100 text-yellow-800' :
    //         row.status === 'Unassigned' ? 'bg-gray-100 text-gray-800' :
    //           'bg-red-100 text-red-800'
    //       }`}>
    //       {row.status}
    //     </span>
    //   ),
    //   tdClassName: 'flex justify-end',
    // },
    // {
    //   label: "Action",
    //   tdClassName: 'flex justify-end',
    //   render: (row) => (
    //     <div className="flex gap-2">
    //       <Button
    //         label="Approve"
    //         onClick={() => handleAssign(row)}
    //         className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded-md text-sm"
    //         disabled={row.status === 'Approved'}
    //       />
    //     </div>
    //   )
    // }
  ];

  // Dealer requests reuse the agent columns but relabel the first column.
  const dealerTableColumns = tableColumns.map((col, i) =>
    i === 0 ? { ...col, label: 'Dealer Name' } : col
  );

  const handleApprove = async () => {
    const data = {
      FasTagIds: [assigningAgent._id],
      remark: approvalNote
    }

    const response = await API.ApproveFastag(JSON.stringify(data));

    if (response.status === 200 && response.success) {
      SuccessToast(response.message);
      dispatch({ type: "REFRESH_DATA" });
      setIsModalOpen(false);
      // Refresh current tab data
      refreshActiveTab();
    } else {
      ErrorToast(response.message);
    }
  }

  // Refresh whichever tab is currently active.
  const refreshActiveTab = () => {
    if (activeTab === 'agentRequest') {
      fetchAgentRequests(agentRequestsCurrentPage, agentRequestsPageSize, 'agentRequest');
    } else if (activeTab === 'dealerRequest') {
      fetchAgentRequests(dealerRequestsCurrentPage, dealerRequestsPageSize, 'dealerRequest');
    } else if (activeTab === 'myFastagRequest') {
      fetchMyFastagRequests(myFastagRequestsCurrentPage, myFastagRequestsPageSize);
    }
  };

  // Function to fetch agent/dealer requests from the API.
  // `tabName` selects which requester role to fetch and which state to update:
  //   'agentRequest'  -> userRole 'agent',  stored in agentRequests
  //   'dealerRequest' -> userRole 'dealer', stored in dealerRequests
  const fetchAgentRequests = async (page, limit, tabName = 'agentRequest') => {
    const isDealerTab = tabName === 'dealerRequest';
    const userRole = isDealerTab ? 'dealer' : 'agent';

    const setLoading = isDealerTab ? setDealerRequestsLoading : setAgentRequestsLoading;
    const setData = isDealerTab ? setDealerRequests : setAgentRequests;
    const setTotalRecords = isDealerTab ? setDealerRequestsTotalRecords : setAgentRequestsTotalRecords;
    const setTotalPages = isDealerTab ? setDealerRequestsTotalPages : setAgentRequestsTotalPages;

    try {
      setLoading(true);

      const params = { page, limit, userRole };
      const response = await API.GetAllFastagAgentRequest(params);

      if (response && response.status === 200 && response.success) {
        const responseData = response.data || [];
        setData(responseData);

        // Backend returns pagination.total; fall back for older shapes.
        const total = response.pagination?.total ?? response.totalRecords ?? responseData.length ?? 0;
        setTotalRecords(total);
        const calculatedTotalPages = Math.ceil(total / limit) || 1;
        setTotalPages(calculatedTotalPages);
      } else {
        console.error('❌ Requests API Error:', response);
        ErrorToast(response?.message || `Failed to fetch ${userRole} requests`);
        setData([]);
        setTotalRecords(0);
        setTotalPages(1);
      }
    } catch (error) {
      console.error('🔥 Requests Network/Exception Error:', error);
      ErrorToast(`Network error occurred while fetching ${userRole} requests`);
      setData([]);
      setTotalRecords(0);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };

  // Function to fetch my fastag requests from the API
  const fetchMyFastagRequests = async (page, limit) => {
    try {
      setMyFastagRequestsLoading(true);
      // A dealer's own requests are raised up to their distributor and stored as
      // agent-style requests, so they come from the agent-request endpoint scoped
      // to the caller (scope=own). Distributors use their purchase-request endpoint.
      const isDealer = role === 'dealer';
      const response = isDealer
        ? await API.GetAllFastagAgentRequest({ page, limit, scope: 'own' })
        : await API.GetDistributorRequest({ page, limit });
      if (response && response.status === 200 && response.success) {
        const responseData = isDealer
          ? (response.data || [])
          : (response.data?.data || []);
        setMyFastagRequests(responseData);

        // Handle pagination info
        const total = isDealer
          ? (response.pagination?.total ?? responseData.length ?? 0)
          : (response.data?.pagination?.total ?? response.data?.totalRecords ?? responseData.length ?? 0);
        setMyFastagRequestsTotalRecords(total);
        const calculatedTotalPages = Math.ceil(total / limit) || 1;
        setMyFastagRequestsTotalPages(calculatedTotalPages);

        if (responseData.length === 0) {
          console.log('No my fastag requests data returned from API');
        }
      } else {
        console.error('❌ My Fastag Requests API Error:', response);
        ErrorToast(response?.message || 'Failed to fetch my fastag requests');
        setMyFastagRequests([]);
        setMyFastagRequestsTotalRecords(0);
        setMyFastagRequestsTotalPages(1);
      }
    } catch (error) {
      console.error('🔥 My Fastag Requests Network/Exception Error:', error);
      ErrorToast('Network error occurred while fetching my fastag requests');
      setMyFastagRequests([]);
      setMyFastagRequestsTotalRecords(0);
      setMyFastagRequestsTotalPages(1);
    } finally {
      setMyFastagRequestsLoading(false);
    }
  };

  // Handle agent requests page change
  const handleAgentRequestsPageChange = (page) => {
    setAgentRequestsCurrentPage(page);
    fetchAgentRequests(page, agentRequestsPageSize);
  };

  // Handle agent requests page size change
  const handleAgentRequestsPageSizeChange = (newSize) => {
    console.log('Agent Requests page size changed to:', newSize);
    setAgentRequestsPageSize(newSize);
    setAgentRequestsCurrentPage(1); // Reset to first page when changing page size
    fetchAgentRequests(1, newSize);
  };

  // Handle dealer requests page change
  const handleDealerRequestsPageChange = (page) => {
    setDealerRequestsCurrentPage(page);
    fetchAgentRequests(page, dealerRequestsPageSize, 'dealerRequest');
  };

  // Handle dealer requests page size change
  const handleDealerRequestsPageSizeChange = (newSize) => {
    setDealerRequestsPageSize(newSize);
    setDealerRequestsCurrentPage(1); // Reset to first page when changing page size
    fetchAgentRequests(1, newSize, 'dealerRequest');
  };

  // Handle my fastag requests page change
  const handleMyFastagRequestsPageChange = (page) => {
    console.log('My Fastag Requests page changed to:', page);
    setMyFastagRequestsCurrentPage(page);
    fetchMyFastagRequests(page, myFastagRequestsPageSize);
  };

  // Handle my fastag requests page size change
  const handleMyFastagRequestsPageSizeChange = (newSize) => {
    console.log('My Fastag Requests page size changed to:', newSize);
    setMyFastagRequestsPageSize(newSize);
    setMyFastagRequestsCurrentPage(1); // Reset to first page when changing page size
    fetchMyFastagRequests(1, newSize);
  };

  // Fetch data on component mount and when active tab changes
  useEffect(() => {
    fetchAgentRequests(agentRequestsCurrentPage, agentRequestsPageSize, 'agentRequest');
    fetchMyFastagRequests(myFastagRequestsCurrentPage, myFastagRequestsPageSize);
    // Dealers Requests tab only exists for distributors.
    if (isDistributor) {
      fetchAgentRequests(dealerRequestsCurrentPage, dealerRequestsPageSize, 'dealerRequest');
    }
  }, [agentRequestsCurrentPage, agentRequestsPageSize, myFastagRequestsCurrentPage, myFastagRequestsPageSize, dealerRequestsCurrentPage, dealerRequestsPageSize, activeTab, refreshCount]);

  // Initialize assigningAgent for approval modal
  const handleAssign = (agent) => {
    setAssigningAgent(agent);
    setApprovalNote(''); // Reset approval note
    setIsModalOpen(true);
  };

  // Handle deny action
  const handleDeny = async (agent) => {
    if (window.confirm(`Are you sure you want to deny the request from ${agent.user?.username}?`)) {
      try {
        setIsProcessing(true);
        const data = {
          requestId: agent._id,
          requestStatus: "Rejected"
        };

        dispatch(ACTIONS.UpdateAgentRequestStatusAction(JSON.stringify(data)));
      } catch (error) {
        ErrorToast('Failed to deny request');
        setIsProcessing(false);
      }
    }
  };

  // Handle View Details action
  const handleViewDetails = (agent) => {
    setSelectedRequest(agent);
    setViewDetailsModalOpen(true);
  };

  // Watch for updateStatusData changes
  useEffect(() => {
    if (updateStatusData) {
      setIsProcessing(false);
      if (updateStatusData.status === 200 && updateStatusData.success) {
        SuccessToast(updateStatusData.message || 'Request status updated successfully');
        setViewDetailsModalOpen(false);
        setSelectedRequest(null);
        // Refresh data
        refreshActiveTab();
      } else if (updateStatusData.message) {
        ErrorToast(updateStatusData.message);
      }
    }
  }, [updateStatusData]);

  const StatusBadge = ({ status }) => {
    const base = "px-2 py-[2px] rounded-full text-xs font-medium flex items-center gap-1 justify-self-start";
    if (status === "Assigned")
      return <span className={`${base} bg-green-100 text-green-900`}><span className="h-2 w-2 bg-green-500 rounded-full" />Assigned</span>;
    if (status === "Unassigned")
      return <span className={`${base} bg-yellow-100 text-yellow-900`}><span className="h-2 w-2 bg-yellow-500 rounded-full" />Unassigned</span>;
    if (status === "Rejected")
      return <span className={`${base} bg-red-100 text-red-900`}><span className="h-2 w-2 bg-red-500 rounded-full" />Rejected</span>;
    return null;
  };

  // My FASTag request columns - similar to Dashboard table
  const myFastagTableColumns = [
    {
      label: "Requested By",
      key: "name",
      render: (row) => (
        <div>
          <div className="font-medium text-[#1F1715]">{row.user?.username}</div>
          <div className="text-xs text-[#000000]">{row.user?.email}</div>
        </div>
      ),
    },
    { label: "Mobile Number", render: (row) => row.user?.mobileNo },
    {
      label: "Vehicle Class",
      key: "vehicleClass",
      render: (item, idx) => {
        const vehicleClassData = getVehicleClassData(item.vehicleClass);
        return (
          <div className="flex gap-2 items-center">
            <img
              src={vehicleClassData?.tagimage}
              alt="Tag"
              className="w-[34px]"
            />
            <p>{vehicleClassData?.value || item.vehicleClass}</p>
            <div
              className="pl-2 flex items-center cursor-pointer"
              onClick={() => toggleVisibility(idx, item)}
            >
              {visibleRows[idx] ? <Eye className="h-5 w-5" /> : <EyeOff className="h-5 w-5" />}
            </div>
          </div>
        );
      },
    },
    { label: "Requested Date", render: (row) => moment(row.createdAt).format("DD MMMM, YYYY hh:mm A"), },
    { label: "Received Date", render: (row) => moment(row.updatedAt).format("DD MMMM, YYYY hh:mm A"), },
    {
      label: "Quantity",
      key: "quantity",
      render: (row) => row.quantity || 0
    },
    {
      label: "Status",
      key: "status",
      render: (row) => <StatusBadge status={row.status} />,
      tdClassName: 'flex justify-end',
    },
  ];

  // Refresh data manually
  const handleRefresh = () => {
    refreshActiveTab();
  };
  const LeftComponent = () => {
    // Distributors get a dedicated Dealers Requests tab; dealers do not.
    const tabs = [
      { key: 'myFastagRequest', label: 'My FASTag Requests' },
      ...(isDistributor ? [{ key: 'dealerRequest', label: 'Dealers Requests' }] : []),
      { key: 'agentRequest', label: 'Agent Requests' },
    ];

    return (
      <div className="flex items-center mb-[12px]">
        <ul className="flex flex-wrap  text-sm font-medium text-center">
          {tabs.map((t) => (
            <li key={t.key} className="mr-2">
              <button
                onClick={() => setActiveTab(t.key)}
                className={`${activeTab === t.key ? 'bg-red-500 text-white' : 'bg-[#FEF5F5] text-[#1F1715]'
                  } text-[12px] font-medium px-4 py-2 rounded-full`}
              >
                {t.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <>
      <div className="">
        {/* Tabs */}
        <div className="mx-auto mb-6">
          <div className="my-4 flex justify-between items-center">
            <h2 className="text-xl font-semibold">
              {activeTab === 'agentRequest'
                ? 'FASTag Requests'
                : activeTab === 'dealerRequest'
                  ? 'Dealer FASTag Requests'
                  : 'My FASTag Requests'}
            </h2>
            {/* <Button
              label="Refresh"
              onClick={handleRefresh}
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md"
              disabled={activeTab === 'agentRequest' ? agentRequestsLoading : myFastagRequestsLoading}
            /> */}
          </div>

        </div>

        {modalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
            <div className="relative bg-white rounded-[20px] shadow-lg w-full max-w-xl p-6">
              <div className="absolute top-4 right-4 gap-3 flex-row flex">
                <button
                  onClick={() => {
                    setModalOpen(false);
                    if (selectedIndex !== null) {
                      toggleVisibility(selectedIndex, selectedClass);
                    }
                  }}
                  className="text-gray-600 hover:text-red-500"
                >
                  <X size={20} />
                </button>
              </div>
              <h2 className="text-xl font-semibold mb-[4px] text-center">
                {vehicleData?.value}
              </h2>
              <p className="mb-[30px] text-sm text-center">
                {vehicleData?.description}
              </p>
              <div className="relative w-full flex justify-center items-center py-8 px-4">
                <div className="relative bg-white p-8 rounded-2xl shadow-2xl border border-gray-200 max-w-2xl w-full">
                  {/* Decorative corner accents */}
                  <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-red-500 rounded-tl-2xl opacity-20"></div>
                  <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-red-500 rounded-br-2xl opacity-20"></div>

                  {/* Image container with classic frame */}
                  <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl border-2 border-gray-300 shadow-inner">
                    <img
                      src={vehicleData?.cardWebp}
                      alt={vehicleData?.name}
                      className="w-full h-auto object-contain rounded-lg transition-transform duration-500 hover:scale-[1.12]"
                    />
                  </div>

                  {/* Elegant bottom accent */}
                  <div className="mt-6 flex justify-center">
                    <div className="h-1 w-24 bg-gradient-to-r from-transparent via-red-500 to-transparent rounded-full"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <CommonModal
          isOpen={isModalOpen}
          closeOnOutsideClick={false}
          onClose={() => setIsModalOpen(false)}
          title={`FASTag Request: ${assigningAgent?.user?.username}`}
          size="max-w-xl"
          footer={
            <div className="flex justify-end gap-4">
              <Button
                label="Cancel"
                onClick={() => setIsModalOpen(false)}
                className="bg-gray-200 text-gray-800 hover:bg-gray-300 px-4 py-2 rounded-md"
              />
              <Button
                label="Approve"
                onClick={handleApprove}
                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-md"
              />
            </div>
          }
        >
          <div className="grid grid-cols-2 gap-3 mb-3">
            <label className="block text-sm font-medium text-gray-700 ">Assigning Agent : {assigningAgent?.user?.username}</label>
            <label className="block text-sm font-medium text-gray-700 ">Mobile : {assigningAgent?.user?.mobileNo}</label>
            <label className="block text-sm font-medium text-gray-700 ">Vehicle Class : {assigningAgent?.vehicleClass}</label>
            <label className="block text-sm font-medium text-gray-700 ">UTR Number : {assigningAgent?.utrnumber}</label>
            <label className="block text-sm font-medium text-gray-700 ">Quantity : {assigningAgent?.quantity}</label>
            <label className="block text-sm font-medium text-gray-700 ">Total Amount : {assigningAgent?.price}</label>
            <label className="block text-sm font-medium text-gray-700 ">Requested Date : {moment(assigningAgent?.createdAt).format('DD MMMM, YYYY, hh:mm A')}</label>

          </div>

          <label className="block text-sm font-medium text-gray-700 mb-3">Approval Note</label>
          <input
            type="text"
            placeholder="Enter remarks (optional)"
            value={approvalNote}
            onChange={(e) => setApprovalNote(e.target.value)}
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
          />
        </CommonModal>
      </div>

      {/* Conditional Rendering of Tables based on active tab */}
      {activeTab === 'agentRequest' ? (
        <CommonTable
          isPagination={true}
          columns={tableColumns}
          leftComponent={<LeftComponent />}
          data={agentRequests}
          emptyMessage={agentRequestsLoading ? "Loading..." : "No Agent Requests Found"}
          total={agentRequestsTotalRecords}
          currentPage={agentRequestsCurrentPage}
          totalPages={agentRequestsTotalPages}
          setCurrentPage={handleAgentRequestsPageChange}
          itemsPerPage={agentRequestsPageSize}
          setItemsPerPage={handleAgentRequestsPageSizeChange}
          hideDateAndDownload={role === 'distributor' || role === 'dealer'}
        />
      ) : activeTab === 'dealerRequest' ? (
        <CommonTable
          isPagination={true}
          columns={dealerTableColumns}
          leftComponent={<LeftComponent />}
          data={dealerRequests}
          emptyMessage={dealerRequestsLoading ? "Loading..." : "No Dealer Requests Found"}
          total={dealerRequestsTotalRecords}
          currentPage={dealerRequestsCurrentPage}
          totalPages={dealerRequestsTotalPages}
          setCurrentPage={handleDealerRequestsPageChange}
          itemsPerPage={dealerRequestsPageSize}
          setItemsPerPage={handleDealerRequestsPageSizeChange}
          hideDateAndDownload={role === 'distributor' || role === 'dealer'}
        />
      ) : (
        <CommonTable
          isPagination={true}
          columns={myFastagTableColumns}
          leftComponent={<LeftComponent />}
          data={myFastagRequests}
          emptyMessage={myFastagRequestsLoading ? "Loading..." : "No FASTag Requests Found"}
          total={myFastagRequestsTotalRecords}
          currentPage={myFastagRequestsCurrentPage}
          totalPages={myFastagRequestsTotalPages}
          setCurrentPage={handleMyFastagRequestsPageChange}
          itemsPerPage={myFastagRequestsPageSize}
          setItemsPerPage={handleMyFastagRequestsPageSizeChange}
          hideDateAndDownload={role === 'distributor' || role === 'dealer'}
        />
      )}

      {/* View Details Modal */}
      {viewDetailsModalOpen && selectedRequest && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
          <div className="relative bg-white rounded-[20px] shadow-lg w-full max-w-2xl overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-r from-red-500 to-red-600 px-6 py-4 flex justify-between items-center">
              <h2 className="text-xl font-semibold text-white">
                FASTag Request Details
              </h2>
              <button
                onClick={() => {
                  setViewDetailsModalOpen(false);
                  setSelectedRequest(null);
                }}
                className="text-white hover:text-gray-200 transition-colors"
              >
                <X size={24} />
              </button>
            </div>

            {/* Content */}
            <div className="p-6">
              {/* Agent Info Section */}
              <div className="bg-gray-50 rounded-lg p-4 mb-4">
                <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3">Agent Information</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-xs text-gray-500">Agent Name</p>
                    <p className="font-medium text-gray-800">{selectedRequest?.user?.username || 'N/A'}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Mobile Number</p>
                    <p className="font-medium text-gray-800">{selectedRequest?.user?.mobileNo || 'N/A'}</p>
                  </div>

                  <div>
                    <p className="text-xs text-gray-500">Request Date</p>
                    <p className="font-medium text-gray-800">{moment(selectedRequest?.createdAt).format('DD MMMM, YYYY hh:mm A')}</p>
                  </div>
                </div>
              </div>

              {/* Request Details Section */}
              <div className="bg-gray-50 rounded-lg p-4 mb-4">
                <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3">Request Details</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-xs text-gray-500">Vehicle Class</p>
                    <div className="flex items-center gap-2 mt-1">
                      <img
                        src={getVehicleClassData(selectedRequest?.vehicleClass)?.tagimage}
                        alt="Tag"
                        className="w-8 h-8 object-contain"
                      />
                      <p className="font-medium text-gray-800">{getVehicleClassData(selectedRequest?.vehicleClass)?.value || selectedRequest?.vehicleClass}</p>
                    </div>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Requested Quantity</p>
                    <p className="font-medium text-gray-800 text-lg">{selectedRequest?.quantity || 0}</p>
                  </div>
                </div>
              </div>

              {/* Current Status */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6">
                <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">Current Status</h3>
                <span className={`px-3 py-1 rounded-full text-sm font-medium ${selectedRequest?.requestStatus === 'Approved' ? 'bg-green-100 text-green-800' :
                    selectedRequest?.requestStatus === 'Rejected' ? 'bg-red-100 text-red-800' :
                      selectedRequest?.requestStatus === 'Pending' ? 'bg-yellow-100 text-yellow-800' :
                        'bg-gray-100 text-gray-800'
                  }`}>
                  {selectedRequest?.requestStatus || 'Pending'}
                </span>
              </div>

              {/* Close Button */}
              <div className="flex justify-end">
                <Button
                  label="Close"
                  onClick={() => {
                    setViewDetailsModalOpen(false);
                    setSelectedRequest(null);
                  }}
                  className="bg-gray-200 text-gray-800 hover:bg-gray-300 px-6 py-2 rounded-full"
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {assigningAgent && (
        <CommonTableModal
          open={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            setAssigningAgent(null);
            // Refresh data after modal closes
            refreshActiveTab();
          }}
          title={`${assigningAgent?.user?.username} • Requested: ${assigningAgent?.quantity || 0} FASTags`}
          agentName={assigningAgent?.user?.username}
          agentId={assigningAgent?.user?._id}
          requestId={assigningAgent?._id}
          maxQuantity={assigningAgent?.quantity}
          showSearch={true}
          reqVehicleClass={assigningAgent?.vehicleClass}
          sampleFileType={activeTab === 'dealerRequest' ? 'dealerAssignment' : 'agentAssignment'}
        />
      )}
    </>
  );
};

export default MyAgentsRequest;
